import React from 'react';
import ReactDOM from 'react-dom';
import Color from 'color';
import './index.css';
import Chat from './Chat';

const generateToken = (n) => {
  var chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  var token = '';
  for(var i = 0; i < n; i++) {
      token += chars[Math.floor(Math.random() * chars.length)];
  }
  return token;
}

const getParameterByName = (name, url = window.location.href) => {
  name = name.replace(/[[\]]/g, '\\$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

// colors
const addStyle = (styleString) => {
  const style = document.createElement('style');
  style.textContent = styleString;
  document.head.append(style);
}

try {
  if (getParameterByName("color") != null) {
    const color = Color(getParameterByName("color"));
    const rgb = color.rgb().color;
    const yiq = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;

    addStyle(`
    :root {
    --color-primary: ${color.rgb().array().join(',')};
    --color-on-primary: ${yiq < 140 ? '255,255,255' : '0,0,0'};
    }
    `);
  }
} catch (e) {
  console.warn("Cannot parse color");
}

if (getParameterByName("theme") === "floating") {
  document.body.className = "floating"
}

// communication
const notifyWindow = (msg) => {
  window.parent.postMessage(msg, "*");
}

const chatRef = React.createRef();
const token = getParameterByName("token") || generateToken(24);

ReactDOM.render(
  <React.StrictMode>
    <Chat
      ref={chatRef}
      room={window.location.pathname.replace("/e/", "")}
      token={token}
      isAdmin={token.split(".").length === 3}
      username={getParameterByName("username")}
      onIncomingMessage={() => notifyWindow({type: "incomingMessage"})} />
  </React.StrictMode>,
  document.getElementById('root')
);

window.addEventListener("message", function(event) {
  if (typeof event.data !== "object") return;

  switch(event.data.type) {
    case "scrollToBottom":
      chatRef.current?.scrollToBottom();
      break;
    default:
      console.debug("received unknown message", event.data);
      break;
  }
}, false);
